// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clear-button .mat-icon {
  width: 16px;
  vertical-align: bottom;
}

.clear-button {
  width: 20px;
}

.comboRow {
    padding: 0% 3%;
}

.contList {
    padding-left: 3%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/dialogs/containerSelect.dialog.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".clear-button .mat-icon {\n  width: 16px;\n  vertical-align: bottom;\n}\n\n.clear-button {\n  width: 20px;\n}\n\n.comboRow {\n    padding: 0% 3%;\n}\n\n.contList {\n    padding-left: 3%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
